import { Permission } from "../../containers/Permission";
import gql from "graphql-tag";
import client from "../apolloClient";

export function resetUserToAdd() {
  return (dispatch) => {
    dispatch({
      type: "SAVE_ADMIN_USER_TO_ADD",
      user_to_add: [],
    });
  };
}

export function closeModal() {
  return (dispatch) => {
    dispatch({
      type: "HIDE_MODAL",
    });
    dispatch({
      type: "SAVE_ADMIN_USER_TO_ADD",
      user_to_add: [],
    });
    dispatch({
      type: "SAVE_ADMIN_USER_TEAMS",
      user_teams: [],
    });
  };
}

export function openModalCreateUser(team_id = -1) {
  if (team_id > -1) {
    return (dispatch) => {
      dispatch({
        type: "OPEN_MODAL_CREATE_USR",
        toTeam: team_id,
      });
    };
  }
}

export function openModalAddUser(team_id = -1) {
  if (team_id > -1) {
    return (dispatch) => {
      dispatch({
        type: "OPEN_MODAL_ADD_USR",
        toTeam: team_id,
      });
    };
  }
}

export function openModalManageTeam(team_id = -1) {
  if (team_id > -1) {
    return (dispatch) => {
      dispatch({
        type: "OPEN_MODAL_MANAGE_TEAM",
        toTeam: team_id,
      });
    };
  }
}

export function openModalEditUserParams(toUser = null) {
  if (toUser !== null) {
    return (dispatch) => {
      dispatch({
        type: "OPEN_MODAL_EDIT_USER_PARAMS",
        toUser: toUser,
      });
    };
  }
}

export function openModalCreateTeam() {
  return (dispatch) => {
    dispatch({
      type: "OPEN_MODAL_CREATE_TEAM",
    });
  };
}

export function saveRoles() {
  return (dispatch) => {
    const query = gql`
      {
        simcaa_t_roles(order_by: { weight: desc }) {
          id
          role_desc
          role_permissions
          weight
        }
      }
    `;

    client.query({ query }).then((roles) => {
      dispatch({
        type: "SAVE_ADMIN_ROLES",
        roles: roles.data.simcaa_t_roles,
      });
    });
  };
}

export function saveTeams(user_id = null, staff_id = null) {
  return (dispatch, getState) => {
    let query;
    const hasPermisson = Permission(
      true,
      getState().user.user_permissions["can_manage_staff"]
    );
    if (hasPermisson) {
      query = gql`
        {
          simcaa_t_team(where: { idstaff: { _eq: ${
            staff_id || getState().user.idstaff
          } } }, order_by: { id: desc }) {
            id
            name
            email
            idstaff
            status
          }
        }
      `;
    } else {
      query = gql`
        {
          simcaa_t_users(where: { id: { _eq: ${
            user_id || getState().user.id
          } } }) {
            userxteam(order_by: { team: {id: desc} }) {
              id
              team {
                id
                idstaff
                name
                email
                status
              }
              role {
                weight
              }
            }
          }
        }
      `;
    }

    client.query({ query }).then((teams) => {
      let teamsArray;
      if (teams.data && teams.data.simcaa_t_team) {
        teamsArray = teams.data.simcaa_t_team;
      } else {
        teamsArray = teams.data.simcaa_t_users[0].userxteam.map((item) => ({
          ...item.team,
          ...item.role,
        }));
      }

      let teamData = teamsArray.map((team) => {
        team.team_id = team.id;
        team.team_name = team.name;
        team.team_email = team.email;
        team.weight = team.weight ? team.weight : 91;
        team.permissions = hasPermisson
          ? getState().userTeamData.filter((tmd) => tmd.team_id === 1)[0]
              .user_permissions
          : getState().userTeamData.filter((tmd) => tmd.team_id === team.id)[0]
              .user_permissions;
        // delete team.id;
        // delete team.name;
        // delete team.email;
        return team;
      });

      teamData = teamData.map((team) => ({
        ...team,
        permissions: JSON.parse(team.permissions),
      }));

      dispatch({
        type: "SAVE_ADMIN_TEAMS",
        teams: teamData,
      });
    });
  };
}

export function saveUserTeams(team_id) {
  return (dispatch, getState) => {
    let query = gql`
      query getUserTeams{
        simcaa_t_userxteam(where: {team: {id: {_eq: ${team_id}}}}) {
          id
          idteam
          role_id
          user_permissions
          status
          user{
            id
            name
            user
            email
            last_login
            link_web
            organization
            status
            idstaff
            active
          }
        }
      }
    `;
    client.query({ query }).then((data) => {
      // data.data.simcaa_t_userxteam.forEach(el => {
      //   el.user.user_permissions = JSON.parse(el.user.user_permissions);
      // });

      let finalData = data.data.simcaa_t_userxteam.map((item) => {
        let newUser = item;
        newUser.user.role_id = item.role_id;
        newUser.user.user_permissions = JSON.parse(item.user_permissions);
        delete newUser.role_id;
        delete newUser.user_permissions;
        return newUser;
      });

      dispatch({
        type: "SAVE_ADMIN_USER_TEAMS",
        user_teams: finalData,
        // user_teams: data.data.simcaa_t_userxteam
      });
    });
  };
}

export function saveUserToAdd(staff_id, notInTeam, queryUser = null) {
  return (dispatch) => {
    let query;
    if (queryUser) {
      query = queryUser;
    } else {
      query = gql`
        {
          simcaa_t_userxteam(
            distinct_on: iduser,
            where: {
              _and: { idteam: { _neq: ${notInTeam} }, user: { idstaff: { _eq: ${staff_id} } } }
            }
          ) {
            role_id
            user {
              name
              user
              id
              email
              organization
              link_web
            }
          }
          simcaa_t_users(where: { userxteam: { idteam: { _eq: ${notInTeam} } } }) {
            id
          }
        }
      `;
    }

    client.query({ query }).then((users) => {
      let userNotInTeam = users.data.simcaa_t_userxteam.map((item) => {
        let user = item.user;
        user.role_id = item.role_id;
        return user;
      });
      userNotInTeam = userNotInTeam.filter(
        (item) =>
          !users.data.simcaa_t_users.map((el) => el.id).includes(item.id)
      );
      dispatch({
        type: "SAVE_ADMIN_USER_TO_ADD",
        user_to_add: userNotInTeam,
      });
    });
  };
}



// WEBPACK FOOTER //
// ./src/store/actions/AdministrationActions.js